

























import Vue from 'vue';
import Component from 'vue-class-component';
import { mapGetters, mapState } from 'vuex';
import { SUBMODULES_PATHS } from '../../store';
import { CONFIG_GETTERS_KEYS } from '../../store/config/config.const';
import { SEARCH_GETTERS_KEYS } from '../../store/search/search.const';
import { SmartComponentMixin } from '../mixins/smart-component.mixin';

@Component({
  computed: {
    ...mapGetters(SUBMODULES_PATHS.config, {
      components: CONFIG_GETTERS_KEYS.components,
      config: CONFIG_GETTERS_KEYS.config
    }),
    ...mapGetters(SUBMODULES_PATHS.search, {
      suggestion: SEARCH_GETTERS_KEYS.searchBoxSuggestion
    }),
    ...mapState(SUBMODULES_PATHS.empathize, ['selectedIndex']),
    ...mapState(SUBMODULES_PATHS.core, ['inputQuery', 'open'])
  },
  mixins: [SmartComponentMixin('SearchBox')]
})
export default class SearchBox extends Vue {}
